<template>
  <section id="page-blog">
    <div class="container">
      <div class="row">

        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content og-bg-dark">
          <h3>{{ $t('message.title.site.blog') }}</h3>
        </div>
      </div>

      <clearfix :wide="true"></clearfix>

      <div class="row">
        <div class="col-sm-12 content og-bg-light">
          <div v-show="this.$store.state.auth.admin">
            <b-button :size="'large'" :variant="'secondary'" :to="{name: 'Article', params: {id: 'create_new'}}">add article</b-button>
            <br>&nbsp;
          </div>
          <div v-for="article in articles">
            <router-link :to="{name: 'Article', params: {id: article.id}}">{{ article.title }}</router-link> <span class="small">(by {{ article.author }})</span>
          </div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>

    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '../utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        articles: []
      }
    },
    components: {
      Clearfix
    },
    created() {
      Vue.axios.get(config.urls.articles)
      .then((response) => {
        this.articles = response.data.articles
      })
    }
  }
</script>

<style>
  #page-blog {
    background: url('../../assets/img/bg/bg_blog.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// BlogList.vue?7bc4da28